import type { MomentInput } from 'moment'
import type { MomentExtended } from './types'

import { isCurrentDate } from '@app/utils/date-formatter'
import datetimeToMoment from '@app/utils/time-converter'

const formatTimestamp = (
  datetime: MomentInput,
  {
    shouldUseLocalTimezone = false,
    format = 'D MMMM Y, HH:mm z',
    shouldUseRelativeFormatOnCurrentDate = false,
  }: {
    shouldUseLocalTimezone?: boolean
    format?: string
    shouldUseRelativeFormatOnCurrentDate?: boolean
  } = {}
): string | null => {
  const originalMoment = datetimeToMoment(
    datetime,
    shouldUseLocalTimezone
  ) as MomentExtended

  if (!originalMoment.isValid()) {
    return null
  }

  if (shouldUseRelativeFormatOnCurrentDate && isCurrentDate(originalMoment)) {
    return originalMoment.fromNow()
  }

  const formattedMoment = shouldUseLocalTimezone
    ? originalMoment.format(format)
    : originalMoment.strftime(format)

  return formattedMoment
}

export default formatTimestamp
